<div class="device-registration-bg">
  <div class="vertically-centralized px-[20px]">
    <div
      class="device-registration-container min-[100px]:p-[32px] max-w-[496px] min-[768px]:px-[40px] min-[768px]:py-[52px] ">
      <div
        class="title min-[100px]:text-[24px] min-[100px]:leading-[29px] min-[768px]:text-[32px] min-[768px]:leading-[39px]">
        Device Registration
      </div>
      <div class="m-t-8">
        <div class="sub-title">
          {{ useOtp ? (useNewDesignOtpWhatsappUssdDeviceRegistration ? '' : 'Verify your Phone Number') : 'Face Verification' }}
        </div>
      </div>
      <ng-container *ngIf="loading, else content">
        <app-loading [loadingText]="'Please wait...'"></app-loading>
      </ng-container>
      <ng-template #content>

        <ng-conatiner *ngIf="useOtp">
          <ng-container *ngIf="!useNewDesignOtpWhatsappUssdDeviceRegistration else otpContent">

          <div class="m-t-8">
            <div class="note">
              {{
              otpResponse?.message
              || 'We’ve just sent you a 6 digit code. Check your messages and enter it here.'
              }}
            </div>
          </div>
          <div>
            <div class="m-t-32">
              <div>
                <app-kamona-password-input [input]="otp">
                </app-kamona-password-input>
              </div>
            </div>
            <div class="m-t-8">
              <div nz-row nzAlign="middle" nzJustify="space-between">
                <div>
                  <app-otp-count-down (emitRetryAction)="retryOtp()" [countdownType]="countdownType"
                    [expiryTime]="otpSuspensionReleaseTime">
                  </app-otp-count-down>
                </div>
                <div>
                  <div class="otp-hint">
                    {{form.value?.otp?.length || 0}}/6
                  </div>
                </div>
              </div>
            </div>
            <div class="m-t-24">
              <app-ussd-board [ussdCode]="otpResponse?.ussdCode"></app-ussd-board>
            </div>
            <div class="m-t-32">
              <app-form-button-template (emitClose)="goBack()" (emitSubmit)="activateDeviceV2()" [closeBtn]="'Login'"
                [disableButton]="!form.valid" [isMobile]="false" [kamonaFormButtonType]="kamonaDialogButtonType"
                [submitBtn]="'Next'" [submitting]="submitting">
              </app-form-button-template>
            </div>
          </div>
        </ng-container>
        </ng-conatiner>

        <ng-conatiner *ngIf="!useOtp">
          <app-liveliness class="grow flex flex-col" [identityProvider]="identityProvider"
            [reference]="livelinessCheckReference" (nextStepMoved)="livelinessStepCompleted($event)"
            [isSubmitting]="submitting" [isMobileView]="false" [noBottomPadding]="true" [type]="feature"
            [is2FAEnabled]="is2FAEnabled" [username]="user?.loginCredentials?.username">
          </app-liveliness>
        </ng-conatiner>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #otpContent>
		<app-web-kamona-otp-widget
			(emitBack)="goBack()"
			[ussd]="otpResponse?.ussdCode"
			(emitReload)="reloadOtp($event)"
			[currentOtpMode]="currentOTPMode || currentOtpModes?.SMS_MODE"
			[minHeight]="289"
			btnText="Next"
			[canUseWhatsappOTPResend]="useResendOtpViaWhatsapp"
      [canUseSmsOTPResend]="useResendOtpViaSms"
			[canUseNewUssd]="canUseNewUssd"
			[hasResendButtonCountdown]="false"
			[showBothCountDown]="showBothCountDown"
			[submitting]="submitting"
			(emitSubmit)="activateDeviceV3($event)"
			[description]="otpResponse?.message
      || 'We’ve just sent you a 6 digit code. Check your messages and enter it here.'"
			title="Verify Your Phone Number">
		</app-web-kamona-otp-widget>
</ng-template>
